export default __webpack_public_path__ + "static/media/search.0e296968.svg";